var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"px-4 py-4 sm:p-0"},[_c('div',{staticClass:"grid grid-cols-1 items-start gap-4 lg:grid-cols-4 lg:gap-6"},[_c('div',{staticClass:"grid grid-cols-1 gap-4 lg:col-span-3"},[_vm._t("content")],2),_c('div',{staticClass:"grid grid-cols-1 gap-4"},[_vm._t("sidebar")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }